import { CopyField } from '@/components/forms';
import { ConnectionCard } from '@/components/data';

/** Endpoint base da API com botão de copiar. */
export function ApiEndpointCard({ url }: { url: string }) {
  return (
    <ConnectionCard icon="globe" iconTone="sky" title="Endpoint da API" subtitle="Use este endpoint para todas as suas requisições.">
      <CopyField id="api" value={url} copyLabel="Copiar endpoint" ariaLabel="Endpoint da API" />
    </ConnectionCard>
  );
}
